export default __webpack_public_path__ + "static/media/college_collab.d2c02fbe.png";